class Sticky {
    sticky: any;
    stickyElement: any;
    stickyHeight: any;
    stickyWidth: any;
    stickyPos: any;
    constructor() {
      this.stickyElement = $('.js-sticky-el');
      if(!this.stickyElement.length) {
        return
      }else {
        if (window.innerWidth >= 786) {
          this.sticky = $('.js-sticky');
          this.stickyHeight = this.stickyElement.outerHeight();
          this.stickyWidth = this.stickyElement.outerWidth();
          this.stickyPos = this.stickyElement.offset().top
          jQuery(window).scroll(this.stick.bind(this));
        }

      }

    }
    stick() {
      var bottomPos = this.sticky.offset().top + this.sticky.outerHeight() - this.stickyElement.outerHeight();
      var navheight = $("nav").outerHeight();
      var positionTop = $(window).scrollTop() + navheight + 90;
      if(positionTop >= this.stickyPos) {

      if(positionTop >= bottomPos) {

        this.stickyElement.css({
            "top": `auto`,
            "bottom": `0`,
            "position": `absolute`,
            "width": `${this.stickyWidth}px`
        });
      }else {
        this.stickyElement.addClass("is-sticky");
        this.stickyElement.css({
            "top": `${navheight + 20}px`,
            "position": `fixed`,
            "width": `${this.stickyWidth}px`,
            "bottom": `auto`
        });
      }
    }else {
      this.stickyElement.css({
          "top": `0`,
          "position": `relative`,
          "width": `${this.stickyWidth}px`
      });
    }

    }
}
let sticky = new Sticky();


//
// // -----------------------------------------------------------
// // FILTER
// // -----------------------------------------------------------
//
// var Filterposition = function() {
//   	this.stickyElement = jQuery('.js-sticky');
// 		this.stickyHeight = this.stickyElement.outerHeight();
// 		// this.stickyWidthSaved = jQuery(".sticky").closest(".column").outerWidth()
//
// 		this.stickyInnerElement = jQuery('.sticky__inner');
// 		this.stickyWidth = 	jQuery(".sticky").closest(".column").outerWidth();
// 		this.submitbtn = this.stickyElement.find('input[type="submit"]');
// 		this.parse.bind(this);
// 		jQuery(window).resize(this.recalc.bind(this));
//    		jQuery(window).scroll(this.parse.bind(this));
//     	this.height();
//     	jQuery('.is-filter-btn').on('click', this.toggle.bind(this));
// 		this.submitbtn.on('click', this.toggle.bind(this));
// }
//
// Filterposition.prototype.recalc = function() {
// 	this.stickyWidth = jQuery(".sticky").closest(".column").outerWidth();
// 	if (this.stickyWidth < 50) {
// 		this.stickyWidth = this.stickyWidthSaved
// 	}else {
// 		this.stickyWidth = this.stickyWidth;
// 	}
// 	this.filterHeight = this.filter.outerHeight();
// 	this.parse.bind(this)
// }
//
// Filterposition.prototype.parse = function() {
// 		this.containerWidth = jQuery(".container").innerWidth();
// 		this.height();
// 		this.sticky();
// }
//
// Filterposition.prototype.sticky = function() {
//     if (window.innerWidth > 1023) {
//         if ((jQuery('.is-filter_space').offset().top - 128) < jQuery(window).scrollTop()) {
//             this.stickyElement.css({
//                 "top": `${this.menu - 20}px`,
//                 "position": 'fixed',
//                 "left": "50%",
//                 "max-width": `${this.containerWidth}px`,
//                 "width": "100%",
//                 "transform": "translateX(-50%)"
//             });
//             this.stickyInnerElement.css({
//                 "width": `${ this.stickyWidth}px `,
//                 "padding-right": "24px"
//             });
//             this.filter.css({
//                 "top": `${this.element}px`
//             });
//         }
//         if ((jQuery('.is-filter_space').offset().top - 128) > jQuery(window).scrollTop()) {
//             this.stickyElement.css({
//                 "top": `0`,
//                 "position": 'static',
//                 "left": "0%",
//                 "max-width": 'none',
//                 "width": "auto",
//                 "transform": ""
//             });
//           	this.stickyInnerElement.css({
//                 "width": "auto",
//                 "padding": "0 0px"
//             });
//             this.filter.css({
//                 "top": `${this.element}px`
//             });
//         }
//         if (jQuery('.is-news-section').offset().top < (jQuery(window).scrollTop() + this.filterHeight + this.menu + 24)) {
//             this.filter.css({
//                // "top": `${ jQuery(".filtered_result").outerHeight()  - this.filterHeight - 12 }px`
//             });
//             this.stickyElement.css({
//                 "top": `0`,
//                 "position": 'static',
//                 "left": "0%",
//                 "max-width": 'none',
//                 "width": "auto",
//                 "transform": ""
//             });
//             this.stickyInnerElement.css({
//                 "width": "auto",
//                 "padding": "0 0px"
//             });
//
//         }
//     } else {
//         this.stickyElement.css({
//             "top": `0`,
//             "position": 'static',
//             "max-width": 'none',
//             "width": 'auto'
//         });
//     }
// }
